module.exports = __webpack_public_path__ + "img/cover_01.6c99d9bc.png";